import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import Switch from '../../../forms/Switch';

// Matches any 3p DoubleVerify measurement domain. Kept aligned with the
// backend's DV_INTERNAL_PIXEL_AUTO_DETECT_PATTERN so the UI default agrees
// with what the server would compute.
const DV_3P_PIXEL_PATTERN = /https:\/\/(?:tps|vast)\.doubleverify\.com/i;

export default function DvInternalPixel() {
  const { control, setValue, getFieldState, getValues } = useFormContext();
  const autoTag = useWatch({ control, name: 'autoTag' });
  const tag = useWatch({ control, name: 'tag' });

  useEffect(() => {
    // Once the user manually toggles the switch, its dirty flag is set and
    // we stop auto-syncing — the AC says "User should be able to disable
    // the DV internal pixel", which we interpret as: their explicit choice
    // wins.
    if (getFieldState('appendDvInternalPixel').isDirty) return;

    // Auto-detect only when the markup differs from what the server has
    // (dirty = differs from defaultValues, which initial load and post-save
    // both reset from the API response). For saved markup the saved flag is
    // already the answer — without this guard, the post-save reset clears
    // the switch's dirty flag and a deliberately disabled pixel flips back
    // on because the 3p pixel is still in the markup. getFieldState computes
    // dirtiness on demand, unlike formState.defaultValues, which can be a
    // stale snapshot inside this effect.
    if (!getFieldState('autoTag').isDirty && !getFieldState('tag').isDirty) return;

    const source = `${autoTag || ''} ${tag || ''}`;
    const hasDv = DV_3P_PIXEL_PATTERN.test(source);
    if (hasDv !== getValues('appendDvInternalPixel')) {
      // shouldDirty: false — leaves the form clean so a no-op auto-detect
      // doesn't enable the Save button on a freshly loaded creative.
      setValue('appendDvInternalPixel', hasDv, { shouldDirty: false });
    }
  }, [autoTag, tag, getFieldState, getValues, setValue]);

  return <Switch name="appendDvInternalPixel" label="Append DV Internal Pixel" />;
}
